(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_00a2deb"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('x961-footer')) {
  customElements.define('x961-footer', class extends HTMLElement {
    connectedCallback() {
      this.columns = [...this.querySelectorAll('.f961-column')];
      this.sync = () => {
        const desktop = this.clientWidth >= 750;
        if (this.desktop === desktop) return;
        this.desktop = desktop;
        this.columns.forEach(column => { column.open = desktop; });
      };
      this.handleClick = event => {
        if (this.desktop && event.target.closest('.f961-column > summary')) event.preventDefault();
      };
      this.sync();
      this.resize = new ResizeObserver(this.sync);
      this.resize.observe(this);
      this.addEventListener('click', this.handleClick);
    }
    disconnectedCallback() {
      this.resize?.disconnect();
      this.removeEventListener('click', this.handleClick);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
